module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#sports",
      toString: function () {
        return this.url;
      }
    }